import axios from 'axios'

const SousCatégorieService = {}

SousCatégorieService.ajouter =(data,authorization)=>{
return axios.post(`${process.env.REACT_APP_API_URL}/sous-categorie/ajouter`,data,{
    headers:{
    'Authorization': `Bearer ${authorization}` 
    }
})

}

export default SousCatégorieService